export default class AccessibilitySiteTheme {
    constructor() {

        this.storageKey = 'theme-preference'
        this.theme = {
            value: this.getThemePrefence()
        }

        this.html = document.querySelector('html')
        this.btnChangeSiteTheme = document.querySelectorAll('.block.theme .option')
        
        this.ready()

        this.changeSiteTheme()
    }

    ready() {

        if(this.btnChangeSiteTheme) {
            this.btnChangeSiteTheme.forEach((el) => {
                el.addEventListener('click', () => {
                    this.theme.value = el.dataset.theme
                    this.setPreference()
                })
            })
        }
        
    }

    changeSiteTheme() {
        this.html.setAttribute('data-theme', this.theme.value)
    }
    
    setPreference() {
        localStorage.setItem(this.storageKey, this.theme.value)
        this.changeSiteTheme()
    }
    
    getThemePrefence() {
        if (localStorage.getItem(this.storageKey)) {
            return localStorage.getItem(this.storageKey)
        } else {
            return'default'
        }
    }

}